import { FormElementAttributes } from "@types";
import classNames from "classnames";
import { useFormikContext } from "formik";

interface Props extends FormElementAttributes {}

const HiddenInput: React.FC<Props> = (props) => {
  const { commonAttrs } = props;
  const { name, id, class: className } = commonAttrs;
  const { values } = useFormikContext<{ [key: string]: string }>();

  return (
    <input
      type={"hidden"}
      name={name}
      className={classNames(className)}
      id={id}
      value={values[name]}
    />
  );
};

export default HiddenInput;
